import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.18.0_@vue+compile_8c0b3227b66ba8bd268cd5a445b5a8d8/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.18.0_@_924c109f4af11ef2e3b4c46ed1ca038b/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}